import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const MenuLink = (props) => {
  return (
    <li className>
      <Link to={props.link}>
        <i className={`fa fa-${props.icon}`} />
        <span>{props.title}</span>
      </Link>
    </li>
  )
}
MenuLink.displayName = 'MenuLink'
MenuLink.propTypes = {
  link: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string
}
export default MenuLink



// WEBPACK FOOTER //
// ./src/components/aside/MenuLink.js